import components from "./components.json";
import views from "./views.json";

export const de = {
  components,
  views,
};
